const moduleName = 'cambuildr.directive.state-button';
const ngModule   = angular.module(moduleName, []);

ngModule.value('stateButtonHTML', {
    invalid: '<i class="fa fa-exclamation-circle fa-left"></i>',
    //   VALID: $element.html(),
    call: '<i class="fa fa-clock-o fa-left"></i>',
    success: '<i class="fa fa-check fa-left"></i>',
    error: '<i class="fa fa-exclamation-circle fa-left"></i>'
});


ngModule.directive("stateButton", [() => {

    let _stateButtonDirective = {};

    _stateButtonDirective.restrict = 'A';
    _stateButtonDirective.scope = {
        form: '=stateButton',
        activityFlag: '=',
        stateInvalid: '@stateInvalid',
        stateCall: '@stateCall',
        stateSuccess: '@stateSuccess',
        stateError: '@stateError'
    };

    _stateButtonDirective.controller = ["$scope", "$element", "$compile", "stateButtonHTML",  ($scope, $element, $compile, stateHTML) => {

        /**
         * Get Button DOM element
         */
        let $fillElement = $element,

            /**
             * If State is valid use the inner HTML Text
             */
            validState = $fillElement.html();

        function setButtonState() {
            $element.attr('disabled', 'disabled');
            if($scope.form.APICall || $scope.activityFlag) {
                $fillElement.html(`${stateHTML.call} ${$scope.stateCall}`);
            }

            else if($scope.form.APISuccess) {
                $fillElement.html(`${stateHTML.success} ${$scope.stateSuccess}`);
                $element.removeAttr('disabled');
            }

            else if($scope.form.APIError) {
                $fillElement.html(`${stateHTML.error} ${$scope.stateError}`);
            }

            else if($scope.form.$valid) {
                $fillElement.html(validState);
                $element.removeAttr('disabled');
            }

            else if($scope.form.$invalid) {
                $fillElement.html(`${stateHTML.invalid} ${$scope.stateInvalid}`);
            }

            $compile($fillElement.contents())($scope.$parent);
        }


        $scope.$watch('form.$valid', setButtonState);
        $scope.$watch('form.$invalid', setButtonState);
        $scope.$watch('form.APICall', setButtonState);
        $scope.$watch('form.APISuccess', setButtonState);
        $scope.$watch('activityFlag', setButtonState);

    }];

    return _stateButtonDirective;
}]);

module.exports = moduleName;
